'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footnote = function Footnote(_ref) {
    var theme = _ref.theme,
        target = _ref.target,
        bedriftUrl = _ref.bedriftUrl,
        hafslundUrl = _ref.hafslundUrl;

    if (target === 'app') {
        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(theme.footnote, theme.iapFooternote) },
            _react2.default.createElement(
                'p',
                null,
                'Ved kjøp av VG+-abonnement blir betalingen trukket fra iTunes-kontoen din. VG+ autofornyes 24 timer før det eksisterende abonnementet ditt går ut og da blir kontoen din belastet igjen med mindre du har avsluttet det.'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Hvis du vil si opp abonnementet kan du gjøre det via iTunes-kontoen din eller i VG-appen ved å gå til Meny > Innstillinger > Administrer abonnement.'
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'a',
                    { href: 'https://payment.schibsted.no/terms?client_id=4e70a7cee962dd83650f0000' },
                    'Brukervilk\xE5r'
                ),
                _react2.default.createElement(
                    'a',
                    { href: 'https://static.vg.no/privacy/' },
                    'Personvernerkl\xE6ring'
                )
            )
        );
    }

    return _react2.default.createElement(
        'div',
        { 'data-test-tag': '@vg/salesposter:footnote' },
        _react2.default.createElement(
            'div',
            { className: theme.footnote },
            _react2.default.createElement(
                'div',
                { className: theme.promotion },
                _react2.default.createElement(
                    'a',
                    { className: theme.bedriftLink, href: bedriftUrl },
                    'Bedriftsabonnement'
                ),
                '| ',
                _react2.default.createElement(
                    'a',
                    { className: theme.hafslundLink, href: hafslundUrl },
                    'Bli kunde av Hafslund Str\xF8m og f\xE5 VG+ i 6 mnd. til kun 1,-'
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(theme.footer, theme.clearfix) },
            _react2.default.createElement(
                'p',
                null,
                'Abonnementet autofornyes og kan sies opp n\xE5r som helst, men senest 48 timer f\xF8r perioden utl\xF8per.'
            ),
            _react2.default.createElement(
                'div',
                { className: theme.paymentPartner },
                _react2.default.createElement(
                    'span',
                    null,
                    'Betal med Visa eller Mastercard'
                )
            )
        )
    );
};

Footnote.propTypes = {
    theme: _propTypes2.default.shape({
        salesPoster: _propTypes2.default.string,
        footer: _propTypes2.default.string,
        clearfix: _propTypes2.default.string
    }),
    target: _propTypes2.default.string,
    bedriftUrl: _propTypes2.default.string,
    hafslundUrl: _propTypes2.default.string
};

Footnote.defaultProps = {
    theme: {},
    target: 'web',
    bedriftUrl: 'http://pluss.vg.no/kampanjer/pluss/bedrift/',
    hafslundUrl: 'https://www.hafslundstrom.no/campaign/vgpluss/'
};

exports.default = Footnote;
//# sourceMappingURL=Footnote.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/salesposter/lib/cjs/Footnote.js
 ** module id = 736
 ** module chunks = 1
 **/